import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-stat',
    templateUrl: './stat.component.html',
    styleUrls: ['./stat.component.scss'],
    standalone: false
})
export class StatComponent implements OnInit {

  @Input() documentsCount: any = {};
  @Input() planInfo: any = {};

  constructor(private router: Router) {
  }

  ngOnInit(): void { }

  calculatePercentage(used: number, limit: number): number {
    if (!limit) return 0;
    const percentage = (used * 100) / limit;
    return Math.min(Math.round(percentage), 100);
  }

  navigate(type: string) {
    switch (type) {
      case 'totalDoc':
        this.router.navigate(['customer/esign/my-document'], {
          queryParams: { status: null }
        });
        break;

      case 'signedDoc':
        this.router.navigate(['customer/esign/my-document'], {
          queryParams: { status: 'Signed' }
        });
        break;

      case 'pendingDoc':
        this.router.navigate(['customer/esign/my-document'], {
          queryParams: { status: 'Pending' }
        });
        break;

      case 'plan':
        this.router.navigate(['customer/billing']);
        break;

      default:
        console.warn('Invalid type');
    }
  }

}
